import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const miperfil = {
    state: {
        comunicaciones : ''
    },
    getters: {
        getComunicaciones : state => state.comunicaciones
    },
    actions: {

        requestMiPerfil({ commit,dispatch }) {

            return new Promise((resolve, reject) => {
                axios.get('/api/TutorAcademico/dameDatosPerfil').then(response => {
                    if (response.data.status == 0) {
                        resolve(response.data.datos);
                    } else {
                        reject(false);
                        commit('setError', response.data.status);
                    }
                }).catch(function (error) {
                    reject(false);
                    dispatch('sendErrorServer', error.response);
                });
            });
        },
        saveMiPerfil({commit, dispatch}, data) {

            return new Promise((resolve, reject) => {
                axios.post('/api/TutorAcademico/editarDatosPerfil',data).then(response => {
                    if (response.data.status == 0) {
                        resolve(response.data.datos);
                    } else {
                        resolve(false);
                        commit('setError', response.data.status);
                    }
                }).catch(function (error) {
                    reject(false);
                    dispatch('sendErrorServer', error.response);
                });
            });
        },
        requestComunicaciones({ commit,dispatch }) {

            return new Promise((resolve, reject) => {
                axios.get('/api/TutorAcademico/dameComunicaciones').then(response => {
                    if (response.data.status == 0) {
                        resolve(response.data.datos);
                    } else {
                        reject(false);
                        commit('setError', response.data.status);
                    }
                }).catch(function (error) {
                    reject(false);
                    dispatch('sendErrorServer', error.response);
                });
            });
        },
    },
    mutations: {
        setComunicaciones(state, data){
            state.comunicaciones = data;
        }
    }
}

export default miperfil;



// WEBPACK FOOTER //
// ./src/store/miperfil.js